export const PRO_TYPES = ["CA", "CS", "CMA", "FIRM", "PROFESSIONAL"];
export const ACCOUNT_LABEL = {
  CA: "Chartered Accountant", CS: "Company Secretary", CMA: "Cost & Management Accountant", FIRM: "Firm",
  PROFESSIONAL: "Tax Professional", STUDENT: "Student", CLIENT: "Client", OTHER: "Professional", ADMIN: "Admin",
};
export const SIGNUP_TYPES = [
  { value: "CA", title: "CA", text: "Chartered Accountant" },
  { value: "CS", title: "CS", text: "Company Secretary" },
  { value: "CMA", title: "CMA", text: "Cost Accountant" },
  { value: "PROFESSIONAL", title: "Tax Professional", text: "Consultant, advocate" },
  { value: "FIRM", title: "Firm", text: "CA / CS firm" },
  { value: "STUDENT", title: "Student", text: "CA, CS, CMA student" },
];
export const CATEGORIES = ["Income Tax", "GST", "Audit", "Startup", "Finance", "International Tax", "Company Law", "Accounting"];
export const JOB_TYPES = ["Full-time", "Part-time", "Contract", "Internship", "Freelance"];
export const WORK_MODES = ["On-site", "Remote", "Hybrid"];

export const isAdmin = (u) => ["admin", "superadmin"].includes(u?.role) || u?.account_type === "ADMIN";

export const isProfessional = (u) => [...PRO_TYPES, "OTHER"].includes(u?.account_type) || isAdmin(u);

export const isListedPro = (u) => !["ADMIN", "CLIENT"].includes(u?.account_type) && u?.active !== false && u?.is_live !== false;

export const professionOf = (u) => u?.custom_profession || ACCOUNT_LABEL[u?.account_type] || u?.qualification || "Member";

export const membershipActive = (u) =>
  u?.membership_active ?? (!!u?.membership_expiry && new Date(u.membership_expiry) > new Date());
